@import "~animatewithsass/animate.scss";

@mixin content {
  .title {
    font-size: 20px;
    @media (min-width: 768px) and (max-width: 1100px) {
      font-size: 16px !important;
    }
    font-weight: 100;
    padding-bottom: 5px;
  }
}

.clean-row {
  .clean-row-block {
    border-radius: 10px;
    .forced-clean {
      @include content;
    }
    .max-clean-timer {
      .content {
        @include content;
      }
    }
    @media (min-width: 768px) and (max-width: 850px) {
      .tab-view {
        width: 50% !important;
      }
    }
  }
  @media (max-width: 767px) {
    .clean-row-block{
      padding:0;
      .max-clean-timer {
        .content {
          margin: 0 auto 0 0;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/settings/machine-settings/clean/clean.scss